<div
  class="input-container"
  [formGroup]="form"
>
  <span class="input-label">Enter Your ZIP or Postal Code</span>
  <div class="d-flex">
    <div style="flex: 1">
      <input
        type="text"
        class="input"
        #postalCode
        formControlName="postalCode"
        (keyup.enter)="onSearch()"
      >
    </div>
    <div
      class="icon-container"
      (click)="onSearch()"
    >
      <img
        src="assets/svg/ico_search.svg"
        alt="Search Icon"
        width="16"
      >
    </div>
  </div>
  <span
    *ngIf="f.postalCode.value !== '' && f.postalCode.touched && form.hasError('postalCode')"
    class="error"
  >Invalid ZIP or Postal Code format.</span>
</div>

<div *ngIf="showResults">
  <div class="camp-search-query d-flex align-items-center justify-content-center mb-3">
    <ng-container *ngIf="radioOptions?.length > 0; else noData">
      <span class="lato">Sorted by Distance from&nbsp;</span><span class="lato bold">{{ displayInput }}</span>
    </ng-container>
    <ng-template #noData>
      <span class="lato">No Results Found</span>
    </ng-template>
  </div>
  <mat-radio-group>
    <ng-container *ngFor="let option of radioOptions; let isLastChild = last">
      <div
        class="option-container clickable"
        [ngClass]="{'selected': option.selected}"
        (click)="changeCheckedRadio(option)"
        (keyup.enter)="changeCheckedRadio(option)"
      >
        <div class="row no-gutters align-items-center">
          <div class="radio-container col-1">
            <mat-radio-button
              [value]="option.id"
              [checked]="currentSelection && currentSelection.id === option.id"
              (click)="$event.preventDefault()"
              tabindex="0"
            ></mat-radio-button>
          </div>
          <div class="col-8">
            <div
              class="oswald bold primary"
              style="font-size: 1.125rem;"
            >{{ option.name }}</div>
          </div>
          <div class="col-3 text-right">
            <div class="lato bold primary">{{ option.distanceInMi + ' mi' }}</div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col offset-1">
            <div class="lato">{{ option.address1 + ' ' + option.address2 }}</div>
            <div class="lato">{{ option.city + ', ' + option.state + ' ' + option.zipcode }}</div>
          </div>
        </div>
      </div>
      <hr
        *ngIf="!isLastChild"
        style="margin: 0.25rem 0"
      >
    </ng-container>
  </mat-radio-group>
</div>